import(/* webpackMode: "eager", webpackExports: ["PoolProvider"] */ "/vercel/path0/apps/web/src/app/(networks)/(non-evm)/tron/_common/ui/Pools/pool-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BackButton"] */ "/vercel/path0/apps/web/src/ui/pool/BackButton.tsx");
